import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon, MailIcon, ShieldIcon, LockIcon } from 'lucide-react';
export function Hero() {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  const scrollToFooterContact = () => {
    const element = document.getElementById('footer-contact');
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
      window.location.hash = 'footer-contact';
    }
  };
  return <section id="hero" className="pt-32 pb-20 px-6 relative overflow-hidden min-h-screen flex items-center" style={{
    background: 'linear-gradient(135deg, #000000 0%, #0B1220 50%, #1a1a2e 100%)'
  }} data-id="element-166">
      {/* Cypherpunk Background Image */}
      <div className="absolute inset-0 opacity-20" style={{
      backgroundImage: 'url(https://images.unsplash.com/photo-1550751827-4bd374c3f58b?w=1600&q=80)',
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      filter: 'brightness(0.7) contrast(1.2)'
    }} data-id="element-167" />
      {/* Digital Grid Overlay */}
      <div className="absolute inset-0 opacity-10" style={{
      backgroundImage: `linear-gradient(rgba(59, 130, 246, 0.3) 1px, transparent 1px),
                           linear-gradient(90deg, rgba(59, 130, 246, 0.3) 1px, transparent 1px)`,
      backgroundSize: '50px 50px'
    }} data-id="element-168" />
      {/* Gradient Overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-[#0B1220]/70 to-[#0B1220]" data-id="element-169" />
      {/* Animated Particles Effect */}
      <div className="absolute inset-0 overflow-hidden" data-id="element-170">
        {[...Array(20)].map((_, i) => <motion.div key={i} className="absolute w-1 h-1 bg-[#3B82F6] rounded-full" initial={{
        x: Math.random() * window.innerWidth,
        y: Math.random() * window.innerHeight,
        opacity: 0.3
      }} animate={{
        y: [null, Math.random() * window.innerHeight],
        opacity: [0.3, 0.8, 0.3]
      }} transition={{
        duration: Math.random() * 10 + 10,
        repeat: Infinity,
        ease: 'linear'
      }} data-id="element-171" />)}
      </div>
      <div className="max-w-6xl mx-auto text-center relative z-10" data-id="element-172">
        {/* CTA Banner with Icons */}
        <motion.div initial={{
        opacity: 0,
        y: -20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="mb-8 inline-block" data-id="element-173">
          <div className="bg-gradient-to-r from-[#3B82F6] via-[#10B981] to-[#3B82F6] rounded-full px-8 py-3 text-white text-sm font-bold flex items-center gap-3 shadow-lg shadow-blue-500/50 border border-white/20" data-id="element-174">
            <LockIcon className="w-4 h-4" data-id="element-175" />
            <span data-id="element-176">Privacy is Power. Security is Non-Negotiable.</span>
            <ShieldIcon className="w-4 h-4" data-id="element-177" />
          </div>
        </motion.div>
        <motion.h1 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.1
      }} className="text-5xl md:text-7xl font-black text-white leading-tight mb-6" style={{
        textShadow: '0 0 20px rgba(59, 130, 246, 0.5)'
      }} data-id="element-178">
          Hardware That
          <br data-id="element-179" />
          <span className="bg-gradient-to-r from-[#3B82F6] via-[#10B981] to-[#3B82F6] bg-clip-text text-transparent" data-id="element-180">
            Protects Your Freedom
          </span>
        </motion.h1>
        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="text-xl md:text-2xl text-gray-300 mb-8 max-w-4xl mx-auto leading-relaxed font-medium" data-id="element-181">
          UAE-based distributor of hardware wallets, encrypted drives, secure
          phones, RFID wallets, and Faraday gear.
          <br data-id="element-182" />
          <span className="text-white font-bold" data-id="element-183">
            For professionals who refuse to compromise on privacy.
          </span>
        </motion.p>
        {/* Feature Pills */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.3
      }} className="flex flex-wrap items-center justify-center gap-3 mb-12" data-id="element-184">
          {['Encrypted Drives', 'Secure Phones', 'RFID Protection', 'Faraday Gear'].map((item, index) => <div key={index} className="px-4 py-2 bg-white/10 backdrop-blur-sm rounded-lg border border-white/20 text-white text-sm font-semibold" data-id="element-185">
              {item}
            </div>)}
        </motion.div>
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} className="flex flex-col sm:flex-row items-center justify-center gap-4" data-id="element-186">
          <button onClick={scrollToContact} className="px-10 py-5 bg-gradient-to-r from-[#3B82F6] to-[#10B981] text-white rounded-xl text-lg font-bold hover:shadow-2xl hover:shadow-blue-500/50 transition-all hover:scale-105 flex items-center gap-3 border border-white/30" data-id="element-187">
            Request Line Sheet
            <ArrowRightIcon className="w-6 h-6" data-id="element-188" />
          </button>
          <button onClick={scrollToFooterContact} className="px-10 py-5 bg-white/10 backdrop-blur-sm text-white rounded-xl text-lg font-bold border-2 border-white/30 hover:bg-white/20 transition-all hover:shadow-lg flex items-center gap-3" data-id="element-189">
            Contact Sales
            <MailIcon className="w-6 h-6" data-id="element-190" />
          </button>
        </motion.div>
      </div>
    </section>;
}